import styled from 'styled-components';

import { flexAllCenter, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Loader = styled.div`
    ${flexAllCenter};
    width: 100%;
    padding: 5rem 0;
`;

export const Table = styled.div`
    display: flex;
    width: 100%;

    ${respondDown(Breakpoints.sm)`
        flex-direction: column;
        gap: 3rem
    `}
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const TitleColumn = styled(Column)`
    ${respondDown(Breakpoints.sm)`
        display: none;
    `}
`;

export const Cell = styled.div`
    color: ${COLORS.textTertiary};
    margin-bottom: 0.8rem;
    display: flex;
    align-items: center;
    height: 2.4rem;

    span:last-child {
        text-align: right;
    }

    ${respondDown(Breakpoints.sm)`
        justify-content: space-between;
    `}
`;

export const TitleCell = styled(Cell)`
    color: ${COLORS.textGray};
`;

export const MobileLabel = styled.span`
    color: ${COLORS.textGray};
    display: none;

    ${respondDown(Breakpoints.sm)`
        display: inline;
    `}
`;
